// extracted by mini-css-extract-plugin
export default {"key":"SeatReservationKey_key__7AuAu","keySpace":"SeatReservationKey_keySpace__nrNPm"};